<template>
    <div class="profile-dropdown">
        <v-select :multiple="multiple" :disabled="disableDropdown" v-model="currentItem" :style="fullwidth ? 'width: 100%' : $vuetify.breakpoint.mdAndUp ? 'width: 50%' : 'width: 80%'" :items="disableDropdown ? [list[1]] : list"
            single-line item-color="primary" :append-icon="'fxt-chevron-down'" @change="changedValue">
            <template v-slot:selection="{ item }">
                <span class="profile-dropdown__selected" :class="disableDropdown ? 'text--secondary' : ''">{{ item }}</span>
            </template>
        </v-select>
    </div>
</template>

<script>
import ProfileSvc from '../../../services/profile-svc';
let profileSvc = null;
export default {
    props: {
        items: {
            required: true,
            default: [],
            type: Array
        },
        multiple: {
            required: false,
            default: false,
            type: Boolean
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        selectedChain: {
            required: false,
            default: '',
            type: String
        },
        fullwidth: {
            required: false,
            default: false,
            type: Boolean
        },
        defaultValue: {
            required: false,
            default: 'Alle',
            type: String
        }
    },
    data: () => ({
        currentItem: '',
    }),
    computed: {
        list() {
            if (this.$route.path.includes('personvern') || (this.$route.query.title && this.$route.query.title.includes('personvern'))) {
                return ['Fixit og nye salonger'].concat([...new Set(this.items)])
            } else {
                return [this.defaultValue].concat([...new Set(this.items)])
            }
        },
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        disableDropdown() {
            if (!this.$route.path.includes('personvern') && this.list.length == 2) {
                this.currentItem = this.list[1]
                this.changedValue(this.currentItem)
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        changedValue(item) {
            this.$emit('select-item', item)
        },
    },
    mounted() {
        this.$route.path.includes('personvern') || (this.$route.query.title && this.$route.query.title.includes('personvern')) ? this.currentItem = 'Fixit og nye salonger' : this.currentItem = this.defaultValue
    },
    async created() {
        if (this.$route.query.siteId) {
            profileSvc = await ProfileSvc(this.$axios);
            var site = await profileSvc.GetSalonNameBySiteId(this.bookingApi, this.$route.query.siteId)
            if (this.list.includes(site)) {
                this.currentItem = site
                this.changedValue(this.currentItem)
            } else {
                profileSvc.emitSnackbar({
                    message: `Du har ingen favoritter hos ${site}!`,
                    visible: true,
                    duration: 3000,
                    state: 'error'
                })
            }
        }
    },
    watch: {
        selectedChain() {
            if (this.selectedChain != '') {
                this.currentItem = this.selectedChain
                this.changedValue(this.currentItem)
            }
        }
    },
    beforeDestroy() {
        profileSvc = null
    }
}
</script>

<style lang="scss" scoped>
.profile-dropdown {
    &__selected {
        color: var(--v-primary-base);
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
    }
}
</style>